import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  
  SiteName = 'WorldERP®';
  title = 'WorldERP.com';

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com'},
      {property: 'og:type', content: ''},
      {property: 'og:url', content: '/'},
      {property: 'og:image', content: ''}
    ]);
  }

}
